import { useModalStore } from "@/hooks/Modal/hooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { EwaybillAccount, updateEwaybillAccountName } from "@/services/api/ewaybillAccount";
import { EditOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { Form, Input, message, Modal, Tooltip } from "antd";
import { observer } from "mobx-react";
import React from "react";

interface UpdateEwaybillAccountNameButtonProps {
  ewaybillAccount: EwaybillAccount;
  onRefresh: () => void;
}

const UpdateEwaybillAccountNameModal: React.FC<InjectBaseModalProps & UpdateEwaybillAccountNameButtonProps> = observer(
  (props) => {
    const { visible, onCancel, ewaybillAccount, onRefresh } = props;

    const [form] = Form.useForm<{ name: string }>();

    const { loading, run } = useRequest(
      async () => {
        const { name } = await form.validateFields();

        await updateEwaybillAccountName(ewaybillAccount.id, name);

        message.success("修改成功");

        onCancel();

        onRefresh();
      },
      { manual: true }
    );

    return (
      <Modal visible={visible} onCancel={onCancel} title="修改电子面单名称" onOk={run} okButtonProps={{ loading }}>
        <Form form={form}>
          <Form.Item
            label="名称"
            rules={[{ required: true, message: "请输入名称后再保存，不支持保存空名称" }]}
            initialValue={ewaybillAccount.name}
            name="name"
          >
            <Input></Input>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
);

const UpdateEwaybillAccountNameButton: React.FC<UpdateEwaybillAccountNameButtonProps> = function (props) {
  const { ewaybillAccount, onRefresh } = props;

  const modalStore = useModalStore();

  return (
    <Tooltip title="修改拼多多站外电子面单名称为自己能辨认的名称，方便识别和重新授权">
      <EditOutlined
        className="mr5 ml5"
        onClick={() => {
          modalStore.openModal(UpdateEwaybillAccountNameModal, {
            ewaybillAccount,
            onRefresh,
          });
        }}
      />
    </Tooltip>
  );
};

export default observer(UpdateEwaybillAccountNameButton);
